import BlockyHeavyText from "components/custom-texts/blocky-heavy-text";
import { Entry } from "interfaces/entry";
import sharedStyles from "assets/shared-stylesheets/contestant-list-item.module.css";
import styles
  from "components/pool-details/entries/single-selection-entry-list/single-selection-entry-list-styles.module.css";
import entryItemStyles from "../entry-item-styles.module.css";
import { useRef } from "react";
import { useAppSelector } from "state/hooks";
import { getGroupStyles } from "state/slices/group-slice";
import { Spinner } from "react-bootstrap";
import useContestContestantPickAllowedCheck from "hooks/useContestEntryCheck.ts";

interface OpenEntryItemProps {
  item: Entry;
  selectBet: (entry: Entry) => void;
  setHeight?: (height: number) => void;
  isSelected?: boolean;
  projectedWin: number;
  contestEntryId?: string;
}

const SingleSelectionOpenEntryItem = ({
                                        item,
                                        selectBet,
                                        setHeight,
                                        projectedWin,
                                        isSelected = false,
                                        contestEntryId
                                      }: OpenEntryItemProps) => {
  const ref = useRef(null);
  const { isLoading, isPickAllowed } = useContestContestantPickAllowedCheck(item.contestant_name, contestEntryId);
  const { secondary_color: secondaryColor } = useAppSelector(getGroupStyles);

  if (isLoading) {
    return (
      <div className={`${sharedStyles.itemContainer} ${entryItemStyles.container}`}
           style={{ justifyContent: "center" }}>
        <Spinner animation="border" size="sm" />
      </div>
    );
  }

  return (
    <div
      id="div-OpenEntryItem-clickEntryItem"
      onClick={() => {
        if (isPickAllowed) {
          selectBet(item);
          setHeight && setHeight((ref.current as any)?.clientHeight);
        }
      }}
    >
      <div
        ref={ref}
        className={`${sharedStyles.itemContainer} ${entryItemStyles.container}`}
        style={{
          border: isSelected ? `3px solid ${secondaryColor}` : "",
          opacity: isPickAllowed ? 1 : 0.5,
          cursor: isPickAllowed ? "pointer" : "not-allowed"
        }}
      >
        <div className={`${sharedStyles.itemLeftColumnContainer} ${styles.singleSelectionItemLeftColumnContainer}`}>
          <BlockyHeavyText
            className={entryItemStyles.titleText}
          >{`${item.contestant_name}`}</BlockyHeavyText>
          {!isPickAllowed && (
            <BlockyHeavyText
              className={entryItemStyles.labelText}
              style={{ color: "red" }}
            >
              Already picked in this contest
            </BlockyHeavyText>
          )}
          <div className={sharedStyles.inline}>
            <BlockyHeavyText
              className={`${sharedStyles.activeBetsText} ${entryItemStyles.labelText}`}
            >
              Projected Win:&nbsp;
            </BlockyHeavyText>
            <BlockyHeavyText className={entryItemStyles.oddsText}>
              {(projectedWin * 100).toFixed(1)}%
            </BlockyHeavyText>
          </div>
          <div className={sharedStyles.inline}>
            <BlockyHeavyText className={entryItemStyles.labelText}>
              Win Odds:&nbsp;
            </BlockyHeavyText>
            <BlockyHeavyText
              className={entryItemStyles.oddsText}
            >{`${item.odds.toFixed(1)}x`}</BlockyHeavyText>
          </div>
        </div>
        <div
          className={styles.singleSelectionItemRightColumnContainer}
          style={{ backgroundColor: secondaryColor }}
        >
          <BlockyHeavyText>{">"}</BlockyHeavyText>
        </div>
      </div>
    </div>
  );
};

export default SingleSelectionOpenEntryItem;
